import type { FC } from 'react';
import {
    Card,
    CardGroup,
    Inline,
    Selectable,
    SelectableItem,
    SkeletonLine,
} from '@george-labs.com/design-system';
import classNames from 'classnames';

import { ConditionalWrapper } from '@luna/utils-ui';

import { getRandomNumber } from '../ProductSkeletonService';

const DEFAULT_NUMBER_OF_SELECTABLE_ITEMS = 3;
const MIN_WIDTH = 40;
const MAX_CONTENT_WIDTH = 75;
const MAX_LABEL_WIDTH = 50;

interface Props {
    numberOfSelectableItems?: number;
    wrapWithCardGroup?: true;
    'data-cy'?: string;
}

export const SelectableDeliveryItemsSkeleton: FC<Props> = ({
    numberOfSelectableItems = DEFAULT_NUMBER_OF_SELECTABLE_ITEMS,
    wrapWithCardGroup = false,
    'data-cy': dataCy,
}) => (
    <ConditionalWrapper condition={wrapWithCardGroup} wrapper={CardGroup}>
        <Selectable
            type={Selectable.TYPE.RADIO}
            verticalAlign={Selectable.VERTICAL_ALIGN.MIDDLE}
            selectedItems={['']}
            disableUncheckedItems
            data-cy={dataCy}
        >
            {[...Array(numberOfSelectableItems).keys()].map((selectableItem) => {
                const applyMargin = !wrapWithCardGroup && selectableItem !== 0;

                return (
                    <Card
                        key={`card_${selectableItem}`}
                        className={classNames({ 'mt-3': applyMargin })}
                    >
                        <SelectableItem disabled inputClassName="pr-2" value="">
                            <Inline>
                                <SkeletonLine
                                    animated
                                    level={5}
                                    percentageWidth={getRandomNumber(MIN_WIDTH, MAX_LABEL_WIDTH)}
                                />
                            </Inline>
                            <Inline>
                                <SkeletonLine
                                    animated
                                    level={6}
                                    percentageWidth={getRandomNumber(MIN_WIDTH, MAX_CONTENT_WIDTH)}
                                />
                            </Inline>
                        </SelectableItem>
                    </Card>
                );
            })}
        </Selectable>
    </ConditionalWrapper>
);
